import { render, staticRenderFns } from "./govePrivateComm.vue?vue&type=template&id=a9fe4480&scoped=true"
import script from "./govePrivateComm.vue?vue&type=script&lang=js"
export * from "./govePrivateComm.vue?vue&type=script&lang=js"
import style0 from "./govePrivateComm.vue?vue&type=style&index=0&id=a9fe4480&prod&lang=less&scoped=true"
import style1 from "./govePrivateComm.vue?vue&type=style&index=1&id=a9fe4480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fe4480",
  null
  
)

export default component.exports